module.exports = __webpack_public_path__ + "static/media/default_profile_pic.21abedf6.png";